import React from "react";
import { Navigate } from "react-router-dom";

const NonAuthLayout = (props) => {
  // Only check for ADMIN authentication, not user authentication
  // Admin login should be accessible even if a user is logged in
  const adminToken = localStorage.getItem("token");
  const adminData = localStorage.getItem("admin-data");

  // If admin is already logged in, redirect to dashboard
  if (adminToken && adminData) {
    try {
      const admin = JSON.parse(adminData);
      if (admin?._id || admin?.id) {
        return <Navigate to="/dashboard" replace />;
      }
    } catch (err) {
      // Invalid admin data, continue to render the page
      console.error("Invalid admin data in localStorage");
    }
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default NonAuthLayout;
